var map = {
	"./3d-cardboard.svg": 20048,
	"./3d-model.svg": 40261,
	"./3d-tv.svg": 56788,
	"./4v-360.svg": 77548,
	"./4v-crown.svg": 95768,
	"./4v-left.svg": 73336,
	"./4v-pavillion.svg": 50345,
	"./4v-right.svg": 28743,
	"./4v-side-view-table-down.svg": 17172,
	"./4v-side-view-table-up.svg": 46703,
	"./add-model-squared.svg": 17445,
	"./add-model.svg": 71249,
	"./add-person.svg": 85449,
	"./aperture.svg": 16980,
	"./arrow-bold-down.svg": 15126,
	"./arrow-bold-left.svg": 96541,
	"./arrow-bold-right.svg": 86112,
	"./arrow-lt-down.svg": 60681,
	"./arrow-lt-left.svg": 55090,
	"./arrow-lt-right.svg": 69161,
	"./arrow-lt-up.svg": 11174,
	"./arrow-mid-down.svg": 46231,
	"./arrow-mid-left.svg": 99080,
	"./arrow-mid-right.svg": 34615,
	"./arrow-mid-up.svg": 41640,
	"./arrow-selector-down.svg": 79324,
	"./arrow-selector-up.svg": 3799,
	"./arrows-asc.svg": 47774,
	"./arrows-desc.svg": 85480,
	"./available-data.svg": 68170,
	"./back-hand.svg": 14105,
	"./block.svg": 79271,
	"./bookmark-fill.svg": 96702,
	"./bookmark.svg": 38988,
	"./calendar.svg": 8198,
	"./cancelled.svg": 81693,
	"./carbon-project.svg": 44739,
	"./chat.svg": 58478,
	"./check.svg": 30556,
	"./clock-back.svg": 45654,
	"./clock.svg": 142,
	"./close.svg": 93224,
	"./code.svg": 81307,
	"./communities.svg": 11031,
	"./compare-fill.svg": 48245,
	"./compare.svg": 91825,
	"./completed.svg": 57031,
	"./controls.svg": 70986,
	"./cube-rotation.svg": 36854,
	"./cube.svg": 42003,
	"./cut-brand.svg": 74500,
	"./cutwise-drive.svg": 77091,
	"./cutwise.svg": 95052,
	"./deadzone.svg": 65460,
	"./delete.svg": 73645,
	"./description-off.svg": 92746,
	"./description-on.svg": 16884,
	"./diamond-filled.svg": 75453,
	"./diamond.svg": 33568,
	"./distance-to-diamond.svg": 28142,
	"./distance-to-inclusions.svg": 92679,
	"./distance-to-rough.svg": 75181,
	"./documentation.svg": 22170,
	"./download.svg": 73468,
	"./drag-handle.svg": 98413,
	"./drag.svg": 85922,
	"./edit.svg": 4912,
	"./email.svg": 72076,
	"./expand.svg": 74548,
	"./facebook.svg": 73784,
	"./failed.svg": 78051,
	"./file-conversion.svg": 80167,
	"./filter.svg": 67634,
	"./folder-add.svg": 91678,
	"./folder-move.svg": 79690,
	"./folder.svg": 5472,
	"./full-protect.svg": 51089,
	"./fullscreen-off.svg": 67791,
	"./fullscreen-on.svg": 76147,
	"./gem.svg": 74697,
	"./grayscale.svg": 99697,
	"./gyro.svg": 38761,
	"./hamburger.svg": 40721,
	"./help.svg": 72069,
	"./history-event.svg": 86275,
	"./history.svg": 70772,
	"./inclusion.svg": 18058,
	"./inclusions-inside-old.svg": 59922,
	"./inclusions-inside.svg": 88998,
	"./info.svg": 54312,
	"./information.svg": 72222,
	"./jewelry.svg": 51262,
	"./leia-tablet.svg": 97028,
	"./lens-f-11.svg": 77752,
	"./lens-f-16.svg": 56471,
	"./lens-f-28.svg": 80392,
	"./lens-f-infinity.svg": 51182,
	"./lighting-d65.svg": 8888,
	"./lighting-fluorescent.svg": 53529,
	"./lighting-led.svg": 85256,
	"./lighting.svg": 66832,
	"./like-fill.svg": 2561,
	"./like.svg": 67429,
	"./link-add.svg": 76570,
	"./link-share.svg": 67390,
	"./link.svg": 1572,
	"./long-arrow-right.svg": 6539,
	"./marquise.svg": 13551,
	"./media.svg": 85976,
	"./metrics-brightness-faceup.svg": 32674,
	"./metrics-brightness.svg": 67505,
	"./metrics-brilliance.svg": 86955,
	"./metrics-carat.svg": 64933,
	"./metrics-clarity.svg": 87640,
	"./metrics-color-material.svg": 21341,
	"./metrics-color-table.svg": 12858,
	"./metrics-color.svg": 17729,
	"./metrics-culet.svg": 4487,
	"./metrics-cut-perf.svg": 93540,
	"./metrics-cut.svg": 38772,
	"./metrics-durability.svg": 43601,
	"./metrics-fire.svg": 80144,
	"./metrics-fluor-table.svg": 80355,
	"./metrics-fluor.svg": 28672,
	"./metrics-girdle.svg": 26803,
	"./metrics-ident.svg": 35874,
	"./metrics-identification.svg": 77094,
	"./metrics-measurments.svg": 63458,
	"./metrics-normalized–cut-perf.svg": 13230,
	"./metrics-optical-performance-area.svg": 13597,
	"./metrics-optical-performance.svg": 19521,
	"./metrics-optical-symmetry.svg": 40407,
	"./metrics-polish.svg": 68291,
	"./metrics-scintillation.svg": 1901,
	"./metrics-shape.svg": 26699,
	"./metrics-spread.svg": 94489,
	"./metrics-symmetry.svg": 71058,
	"./metrics-transparency.svg": 25446,
	"./models-linked.svg": 83100,
	"./more-circles.svg": 61023,
	"./more.svg": 17431,
	"./multistage.svg": 63091,
	"./my-lists.svg": 82822,
	"./next.svg": 24711,
	"./oval.svg": 84880,
	"./palette.svg": 31809,
	"./pause.svg": 11994,
	"./pencil.svg": 84651,
	"./pending.svg": 19405,
	"./pin-filled.svg": 96741,
	"./pin-off.svg": 63317,
	"./pin-on.svg": 40897,
	"./pin-unfilled.svg": 88271,
	"./pinterest.svg": 72474,
	"./play.svg": 67866,
	"./plus.svg": 55604,
	"./precise-fast.svg": 68030,
	"./prev.svg": 6907,
	"./princess.svg": 62193,
	"./printer.svg": 35456,
	"./private-access-for-users.svg": 55097,
	"./products-new.svg": 45549,
	"./products-removed.svg": 18847,
	"./project-shared.svg": 36515,
	"./project.svg": 43731,
	"./protect.svg": 60393,
	"./qr.svg": 20933,
	"./radar.svg": 4752,
	"./reprojection.svg": 51568,
	"./reset-camera.svg": 22819,
	"./rough-2.svg": 30446,
	"./rough-caverns.svg": 61470,
	"./rough-inclusions.svg": 12277,
	"./rough-shared.svg": 98187,
	"./rough-surface.svg": 25949,
	"./rough.svg": 90603,
	"./round.svg": 32580,
	"./search.svg": 95400,
	"./second-display.svg": 90573,
	"./selector-down.svg": 21408,
	"./selector-up.svg": 39283,
	"./settings-off.svg": 49595,
	"./settings-on.svg": 39935,
	"./share-outline.svg": 60168,
	"./share.svg": 54621,
	"./show-all.svg": 82001,
	"./singlescale-off.svg": 52686,
	"./singlescale-on.svg": 56952,
	"./sort-down.svg": 82929,
	"./sort-up.svg": 17902,
	"./spectrum-cuboid.svg": 23840,
	"./spectrum-cushion-fancy.svg": 98079,
	"./spectrum-cushion.svg": 43859,
	"./spectrum-emerald.svg": 64150,
	"./spectrum-heart.svg": 82826,
	"./spectrum-lighting-d65.svg": 93634,
	"./spectrum-lighting-fluorescent.svg": 32487,
	"./spectrum-lighting-led.svg": 5534,
	"./spectrum-lighting.svg": 89566,
	"./spectrum-marquise.svg": 39569,
	"./spectrum-other.svg": 78616,
	"./spectrum-oval-fancy.svg": 66798,
	"./spectrum-oval.svg": 91058,
	"./spectrum-pear.svg": 35042,
	"./spectrum-princess.svg": 65463,
	"./spectrum-radiant.svg": 57639,
	"./spectrum-rough.svg": 853,
	"./spectrum-round.svg": 33590,
	"./star-outline.svg": 1829,
	"./star.svg": 61244,
	"./swap.svg": 52141,
	"./theme-dark.svg": 94120,
	"./theme-light.svg": 17032,
	"./touch-inclusions.svg": 49108,
	"./user-billing-eur.svg": 40960,
	"./user-billing-usd.svg": 93148,
	"./user-import.svg": 49377,
	"./user-logout.svg": 56136,
	"./user-my-collections.svg": 83404,
	"./user-profile.svg": 18033,
	"./view-big.svg": 64362,
	"./view-chart.svg": 92920,
	"./view-combo-lg.svg": 84352,
	"./view-combo.svg": 18146,
	"./view-ex-small.svg": 1789,
	"./view-little.svg": 32204,
	"./view-small.svg": 14981,
	"./view-tab.svg": 35821,
	"./warning.svg": 91848,
	"./wechat.svg": 13134,
	"./whatsapp.svg": 54310,
	"./widgets.svg": 21851,
	"./window.svg": 54568,
	"./x-twitter.svg": 3906,
	"./zoom-in.svg": 74651,
	"./zoom-out.svg": 92638,
	"./zoom-to-fit.svg": 22067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;